import { useContext, useEffect, useState } from "react"
import { ApplicationData } from "types"
import { AppRoutes } from "utilities/constants"
import { ClientContext } from "context/ClientContext"
import { LayoutProvider } from "./LayoutProvider"
import { Route, Routes, useLocation } from "react-router-dom"
import { LogoutPage } from "pages/LogoutPage"
import { env } from "env"

export const Unauthenticated = () => {
  const { client } = useContext(ClientContext)
  const location = useLocation()

  const [applicationData, setApplicationData] =
  useState<ApplicationData | null>(null)

  useEffect(() => {
    if (!env.DEV) {
      setApplicationData(client?.data ?? ({} as ApplicationData))
    } else {
      import("data/colleges").then(({ COLLEGES }) => {
        const activeCollege = COLLEGES.find(c => c.currentlyActive)!
        setApplicationData(activeCollege.data)
      })
    }
  }, [client])

  const isDataLoaded = RegExp(AppRoutes.logout).exec(location.pathname) !== null

  if (!applicationData) return null

  return (
    <LayoutProvider
      applicationData={applicationData}
      isDataLoaded={isDataLoaded}
    >
      <Routes>
        <Route
          key={AppRoutes.logout}
          path={AppRoutes.logout}
          element={<LogoutPage />}
        />
      </Routes>
    </LayoutProvider>
  )
}
